import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "bg-primary/10 text-primary ring-primary/20 hover:bg-primary/15",
        secondary: "bg-secondary text-secondary-foreground ring-border hover:bg-secondary/80",
        destructive: "bg-destructive/10 text-destructive ring-destructive/20 hover:bg-destructive/15",
        outline: "bg-transparent text-foreground ring-border",
        success: "bg-success/10 text-success ring-success/20",
        warning: "bg-[hsl(var(--warning)/0.10)] text-[hsl(var(--warning))] ring-[hsl(var(--warning)/0.20)]",
        info: "bg-[hsl(var(--info)/0.10)] text-[hsl(var(--info))] ring-[hsl(var(--info)/0.20)]",
        accent: "bg-accent/15 text-[hsl(var(--accent))] ring-accent/30 hover:bg-accent/20",
        neutral: "bg-muted text-muted-foreground ring-border",
        solid: "border-transparent bg-primary text-primary-foreground ring-transparent hover:bg-primary/90",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
